/**
 * Tenant wallet balance — GET /api/tenant/gateway/balance.
 *
 * Loading is `balance === null && !error`; error is `error !== null` (balance stays
 * whatever it last was, so a failed background refresh doesn't blank a screen the
 * practitioner was already reading); there is no "empty" state distinct from loading —
 * the endpoint always answers with the four buckets, zeroed if the tenant has never sold
 * anything, which the consuming component renders as "0.00" rather than a placeholder.
 */
import { useCallback, useEffect, useState } from "react";
import defaultGatewayApi from "../api";

export function useTenantBalance(gatewayApi = defaultGatewayApi) {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const data = await gatewayApi.getBalance();
      setBalance(data);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [gatewayApi]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { balance, loading, error, reload };
}

export default useTenantBalance;
